// /Users/caffas/Documents/Sistemas/vsadmin/admin/admin-app/src/Pages/Supports/index.js
import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    EmailField,
    TextInput,
    FilterButton,
    CreateButton,
    ExportButton,
    TopToolbar,
    Show, 
    SimpleShowLayout,
    DateField,
    useRecordContext
} from 'react-admin';

const UserFilters = [
    <TextInput source="q" label="Buscar" alwaysOn />,
    <TextInput source="name" label="User Name" />,
    <TextInput source="email" label="Email" />,
    <TextInput source="subject" label="Subject" />,
    <TextInput source="category" label="Category" />,
    <TextInput source="urgency" label="Urgency" />,
];

const UserListActions = () => (
    <TopToolbar>
    <FilterButton />
    <ExportButton />
    </TopToolbar>
);

// Componente personalizado para mostrar urgencia con colores usando useRecordContext
const UrgencyField = ({ source }) => {
    const record = useRecordContext();
    
    // Verificar que record existe
    if (!record) {
        return <span>-</span>;
    }
    
    // Obtener el valor de urgencia
    const urgency = record[source];
    
    // Verificar si urgency es undefined o null
    if (urgency === undefined || urgency === null) {
        return <span>-</span>;
    }
    
    // Definir colores según el nivel de urgencia
    const getUrgencyStyle = (urgencyLevel) => {
        const styles = {
            padding: '4px 8px',
            borderRadius: '4px',
            fontWeight: 'bold',
            textAlign: 'center',
            color: 'white',
            display: 'inline-block',
            minWidth: '60px'
        };

        // Convertir a string y limpiar espacios
        const level = String(urgencyLevel).toLowerCase().trim();

        switch (level) {
            case 'high':
            case 'alta':
            case 'urgent':
                return { ...styles, backgroundColor: '#f44336' }; // Rojo
            case 'medium':
            case 'media':
            case 'moderate':
                return { ...styles, backgroundColor: '#ff9800' }; // Naranja
            case 'low':
            case 'baja':
            case 'normal':
                return { ...styles, backgroundColor: '#4caf50' }; // Verde
            default:
                return { ...styles, backgroundColor: '#9e9e9e' }; // Gris por defecto
        }
    };

    return (
        <span style={getUrgencyStyle(urgency)}>
            {urgency}
        </span>
    );
};

export const SupportList = () => (
    <List
    filters={UserFilters}
    actions={<UserListActions />}
    perPage={10}
    sort={{ field: 'date', order: 'DESC' }}
    >
    <Datagrid>
    <TextField source="id" />
    <TextField source="name" label="User Name" />
    <EmailField source="email" label="Email" />
    <TextField source="subject" label="Subject" />
    <TextField source="message" label="message" />
    <TextField source="caetgory" label="Category" />
    <UrgencyField source="urgency" label="Urgency" />
    <DateField source="date" label="Date" />
    </Datagrid>
    </List>
);
